import React from "react";
import Select from "react-select";
import { Col, Input, Row } from "reactstrap";
import { mustBeArray } from "../../utils/lib";

const NewOilRequestForm = ({
  values,
  handleFieldChange,
  clientNameList,
  locationList,
  handleLocationChange,
  saveLoading,
  handleSave,
}) => {
  return (
    <React.Fragment>
      <label className="form-control-label" htmlFor="firstName">
        First Name:
      </label>
      <Row className="mb-1">
        <Col lg={5} md={8} sm={12}>
          <Input
            value={values && values.firstName}
            onChange={handleFieldChange}
            name="firstName"
          />
        </Col>
      </Row>

      <label className="form-control-label" htmlFor="lastName">
        Last Name:
      </label>
      <Row className="mb-1">
        <Col lg={5} md={8} sm={12}>
          <Input
            value={values && values.lastName}
            onChange={handleFieldChange}
            name="lastName"
          />
        </Col>
      </Row>

      <label className="form-control-label" htmlFor="clientId">
        Client Name:
      </label>
      <Row className="mb-1">
        <Col lg={5} md={8} sm={12}>
          <Select
            name="clientId"
            value={values && values.clientId}
            options={clientNameList}
            onChange={e => handleFieldChange(e)}
            labelKey={"toClientName"}
            valueKey={"toClientId"}
          />
        </Col>
      </Row>

      <label className="form-control-label" htmlFor="location">
        Location:
      </label>
      {mustBeArray(locationList).map((data, index) => {
        return (
          <Row className="mb-q" key={index}>
            <Col lg={5} md={8} sm={12} key={data.id}> 
                {/* <span className="mr-h">{index + 1}.</span> */}
                <Input
                  type="checkbox"
                  className=" ml-h mr-2 hand" 
                  style={{marginTop: "8px !important"}}
                  checked={mustBeArray(
                    values && values.locations
                  ).includes(data.toLocationId)}
                  onChange={e => handleLocationChange({id: data.toLocationId})}
                /> 
                <span className="ml-2 pl-q">{data.toLocationName}</span>
            </Col>
          </Row>
        );
      })}

      <label className="form-control-label mt-1" htmlFor="emailAddress">
        Email:
      </label>
      <Row className="mb-1">
        <Col lg={5} md={8} sm={12}>
          <Input
            value={values && values.emailAddress}
            onChange={handleFieldChange}
            name="emailAddress"
          />
        </Col>
      </Row>

      <label className="form-control-label" htmlFor="phoneNumber">
        Phone:
      </label>
      <Row className="mb-1">
        <Col lg={5} md={8} sm={12}>
          <Input
            value={values && values.phoneNumber}
            onChange={handleFieldChange}
            name="phoneNumber"
          />
        </Col>
      </Row>

      <label className="form-control-label" htmlFor="otherInformation">
        Other Information:
      </label>
      <Row className="mb-1">
        <Col lg={5} md={8} sm={12}>
          <Input
            type="textarea"
            rows={4}
            value={values && values.otherInformation}
            onChange={handleFieldChange}
            name="otherInformation"
          />
        </Col>
      </Row>

      <Row className="mb-1 mt-h">
        <Col lg={5} md={8} sm={12}>
          <button
            className={`btn btn-success urgent-request-button mobile-screen-button full-width
                                            ${
                                              saveLoading
                                                ? "no-pointer-events"
                                                : ""
                                            }`}
            onClick={handleSave}
          >
            {saveLoading ? "Submitting" : "Submit"}
          </button>
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default NewOilRequestForm;
